import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { dateTimeReportFormatter } from "../../fomatters/DateFormatter";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function ChangedWagers() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [startPlacedDate, setStartPlacedDate] = useState(startDateValue);
  const onStartPlacedDateChange = useCallback(
    (event) => setStartPlacedDate(event.target.value),
    []
  );

  const [endPlacedDate, setEndPlacedDate] = useState(endDateValue);
  const onEndPlacedDateChange = useCallback(
    (event) => setEndPlacedDate(event.target.value),
    []
  );

  const [startSettledDate, setStartSettledDate] = useState(startDateValue);
  const onStartSettledDateChange = useCallback(
    (event) => setStartSettledDate(event.target.value),
    []
  );

  const [endSettledDate, setEndSettledDate] = useState(endDateValue);
  const onEndSettledDateChange = useCallback(
    (event) => setEndSettledDate(event.target.value),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [player, setPlayer] = useState("");
  const onPlayerChange = useCallback(
    (event) => setPlayer(event.target.value),
    []
  );

  const [user, setUser] = useState("");
  const onUserChange = useCallback((event) => setUser(event.target.value), []);

  const [station, setStation] = useState("");
  const onStationChanged = useCallback(
    (event) => setStation(event.target.value),
    []
  );

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  const [type, setType] = useState(0);
  const onTypeChange = useCallback(
    (event) => setType(Number(event.target.value)),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  const [lineType, setLineType] = useState("");
  const onLineTypeChanged = useCallback((l) => setLineType(l), []);
  const { values: lineTypes } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/LineType/GetLineTypes`,
  });

  const [sport, setSport] = useState("");
  const onSportChanged = useCallback((s) => setSport(s), []);
  const { values: sports } = useDataFormatterHook({
    addEmpty: true,
    value: "idSport",
    text: "sportName",
    path: `/Player/GetSports`,
  });

  const [league, setLeague] = useState("");
  const onLeagueChanged = useCallback((l) => setLeague(l), []);
  const { values: leagues } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/League/League_GetAllLeagues`,
  });

  const [voidReason, setVoidReason] = useState("");
  const onVoidReasonChanged = useCallback((v) => setVoidReason(v), []);
  const { values: voidReasons } = useDataFormatterHook({
    addEmpty: true,
    value: "voidReason",
    text: "voidReason",
    path: `/Wager/VoidReason_GetList`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Line Type"
          name="name"
          data={lineTypes}
          placeholder="DataFormatter"
          setSelectValue={onLineTypeChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Player"
          type="text"
          value={player}
          size="small"
          onChange={onPlayerChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="User"
          type="text"
          value={user}
          size="small"
          onChange={onUserChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Station"
          type="number"
          value={station}
          size="small"
          onChange={onStationChanged}
          InputLabelProps={{ shrink: true }}
        />
        <div>
          <SubGroup title="Display">
            <FormControl component="fieldset">
              <RadioGroup label value={type} onChange={onTypeChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="All"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Deleted"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Edited"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={3} size="small" color="primary" />}
                  label="Filled Open"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={4} size="small" color="primary" />}
                  label="Changed Risk"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <InputSelect
          variant="outlined"
          size="small"
          label="Sport"
          name="name"
          data={sports}
          placeholder="DataFormatter"
          setSelectValue={onSportChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="League"
          name="name"
          data={leagues}
          placeholder="DataFormatter"
          setSelectValue={onLeagueChanged}
          startValue={""}
        />

        <SubGroup
          title="Placed Date"
          className="grid grid-cols-2 col-span-2 p-4"
        >
          <TextField
            className="flex-1"
            required
            variant="outlined"
            id="gameDateTime"
            label="From"
            type="date"
            value={startPlacedDate}
            size="small"
            onChange={onStartPlacedDateChange}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            required
            variant="outlined"
            id="gameDateTime"
            label="To"
            type="date"
            value={endPlacedDate}
            size="small"
            onChange={onEndPlacedDateChange}
            InputLabelProps={{ shrink: true }}
          />
        </SubGroup>
        <SubGroup
          title="Settled Date"
          className="grid grid-cols-2 col-span-2 p-4"
        >
          <TextField
            className="flex-1"
            required
            variant="outlined"
            id="gameDateTime"
            label="From"
            type="date"
            value={startSettledDate}
            size="small"
            onChange={onStartSettledDateChange}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            required
            variant="outlined"
            id="gameDateTime"
            label="To"
            type="date"
            value={endSettledDate}
            size="small"
            onChange={onEndSettledDateChange}
            InputLabelProps={{ shrink: true }}
          />
        </SubGroup>
        <InputSelect
          variant="outlined"
          size="small"
          label="Void Reason"
          name="name"
          data={voidReasons}
          placeholder="DataFormatter"
          setSelectValue={onVoidReasonChanged}
          startValue={""}
        />
      </div>
      <Report
        exportCSV={false}
        groupBy={({
          ticketNumber,
          lastModificationChanged,
          changeStatus,
          loginNameChanged,
        }) =>
          `${ticketNumber} ${dateTimeReportFormatter(
            lastModificationChanged
          )} ${changeStatus} by ${loginNameChanged}`
        }
        title="Changed Wagers Report"
        getUrl={() => "/Reports/Report_Changed_Wagers_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Office: office,
          Group: group,
          Book: book,
          LineType: lineType,
          AgentFrom: agentFrom,
          AgentTo: agentTo,
          Distributor: distributor,
          Player: player,
          User: user,
          Station: station,
          Type: type,
          Sport: sport,
          League: league,
          StartPlacedDate: startPlacedDate,
          EndPlacedDate: endPlacedDate,
          StartSettledDate: startSettledDate,
          EndSettledDate: endSettledDate,
          VoidReason: voidReason,
        })}
        getProcess={(data) => [
          {
            ...data?.[0],
            description: data?.[0]?.completeDescription,
            chgDescription: data?.[0]?.chgCompleteDescription,
          },
          ...data.map((item) => ({
            ...item,
            player: "",
            ticketNumber: "",
            placedDate: "",
            riskAmount: "",
            winAmount: "",
            phoneLine: "",
            loginName: "",
            description: item.descriptionDetail,
            chgDescription: item.chgDetailDescription,
            chgPlacedDate: "",
            chgRiskAmount: "",
            chgWinAmount: "",
          })),
        ]}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="player">
          Player
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="ticketNumber"
          dataFormat={dateTimeReportFormatter}
        >
          Ticket
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="placedDate"
          dataFormat={dateTimeReportFormatter}
        >
          Placed Date
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="description"
          className="table-header-groupped-left"
        >
          Description
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="riskAmount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Risk
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="winAmount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Win
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="phoneLine"
          className="table-header-groupped-left"
        >
          Phone
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="loginName"
          className="table-header-groupped-right"
        >
          User
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="chgDescription">
          Description
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="chgRiskAmount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Risk
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="chgWinAmount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Win
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="chgStatus"
          className="table-header-groupped-right"
        >
          New Strat
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default ChangedWagers;
